var map = {
	"./2018-05-01-01.jpg": 59,
	"./2018-11-11-01.jpg": 60,
	"./2019-01-31-01.png": 61,
	"./2019-02-04-01.jpg": 62,
	"./2019-02-15-01.jpg": 63,
	"./2019-03-02-01.png": 64,
	"./2019-03-14-01.jpg": 65,
	"./2019-03-14-02.jpg": 66,
	"./2019-03-15-01.jpg": 67,
	"./2019-04-11-02.jpg": 68,
	"./2019-04-12-01.jpg": 69,
	"./2019-05-18-01.jpg": 70,
	"./2019-06-03-01.jpg": 71,
	"./2019-07-19-01.jpg": 72,
	"./2019-07-31-01.jpg": 73,
	"./2019-08-22-01.jpg": 74,
	"./2020-02-26-01.jpg": 75,
	"./2020-05-27-01.jpg": 76,
	"./2020-10-16-01.jpg": 77,
	"./2020-12-12-01.jpg": 78,
	"./2020-12-16-01.jpg": 79,
	"./2021-02-09-01.jpg": 80,
	"./2022-10-17-01.png": 81,
	"./2022-10-25-01.png": 82,
	"./2023-07-28-01.png": 83,
	"./2024-04-10-01.png": 84,
	"./2024-05-07-01.jpg": 85,
	"./2024-07-10-01.jpg": 86,
	"./2024-08-03-01.png": 87,
	"./2024-09-01-01.jpg": 88,
	"./2025-04-29-01.jpg": 89,
	"./2025-05-01-01.jpg": 90,
	"./2025-05-06-01.jpg": 91,
	"./baseimage.png": 47,
	"./news.psd": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 346;